module.exports = __webpack_public_path__ + "img/cyber-insurance-faq.b02ee17e.jpg";